(() => {
  const dialog = document.querySelector('.agc-links-dialog');
  const form = document.querySelector('[data-collab-form]');
  const openers = document.querySelectorAll('[data-collab-open]');
  const closeButton = document.querySelector('[data-collab-close]');
  if (!dialog || !form || !openers.length || !closeButton) return;

  let trigger = null;
  openers.forEach((button) => {
    button.addEventListener('click', () => {
      trigger = button;
      dialog.showModal();
    });
  });

  const closeDialog = () => dialog.close();
  closeButton.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });
  dialog.addEventListener('close', () => {
    if (trigger) trigger.focus();
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;

    const data = new FormData(form);
    const message = [
      'Hola! Quiero colaborar con Aguacero.',
      '',
      `Nombre: ${data.get('name')}`,
      `Redes: ${data.get('social')}`,
      `Portafolio: ${data.get('portfolio') || 'No especificado'}`,
      `Por qué: ${data.get('why') || 'No especificado'}`
    ].join('\n');

    window.open(
      `https://wa.me/5218124203743?text=${encodeURIComponent(message)}`,
      '_blank',
      'noopener'
    );
  });
})();

(() => {
  const slides = [...document.querySelectorAll('[data-links-slide]')];
  const caption = document.querySelector('[data-links-caption]');
  const heading = document.querySelector('[data-links-heading]');
  const title = document.querySelector('#links-title');
  const next = document.querySelector('[data-links-next]');
  const pause = document.querySelector('[data-links-pause]');
  const position = document.querySelector('[data-links-position]');
  if (slides.length < 2 || !caption || !heading || !title || !next || !pause || !position) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0, timer, busy = false, paused = reduced.matches;
  const blocked = () => paused || document.hidden || !!document.querySelector('dialog[open]');
  const updateControl = () => {
    pause.setAttribute('aria-pressed', String(paused));
    pause.setAttribute('aria-label', paused ? 'Reproducir presentación' : 'Pausar presentación');
  };
  const schedule = () => {
    clearTimeout(timer);
    if (!blocked()) timer = setTimeout(() => change(), 7000);
  };
  const change = async () => {
    if (busy) return;
    busy = true;
    clearTimeout(timer);
    let candidate = (index + 1) % slides.length;
    try {
      for (let attempt = 0; attempt < slides.length - 1; attempt++) {
        const photo = slides[candidate].querySelector('img');
        try {
          photo.loading = 'eager';
          await photo.decode();
          title.getAnimations().forEach(animation => animation.cancel());
          if (!reduced.matches) await title.animate([{opacity:1},{opacity:0}], {duration:180,fill:'forwards'}).finished;
          slides[index].classList.remove('is-active');
          slides[index].setAttribute('aria-hidden','true');
          index = candidate;
          slides[index].classList.add('is-active');
          slides[index].removeAttribute('aria-hidden');
          heading.textContent = slides[index].dataset.heading;
          caption.textContent = slides[index].dataset.caption;
          position.textContent = `${index + 1} / ${slides.length}`;
          if (!reduced.matches) title.animate([{opacity:0,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}], {duration:600,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
          break;
        } catch (_) { candidate = (candidate + 1) % slides.length; }
      }
    } finally { busy = false; schedule(); }
  };
  next.addEventListener('click', change);
  pause.addEventListener('click', () => { paused = !paused; updateControl(); schedule(); });
  document.addEventListener('visibilitychange', schedule);
  const dialogs = new MutationObserver(schedule);
  document.querySelectorAll('dialog').forEach(dialog => dialogs.observe(dialog, {attributes:true,attributeFilter:['open']}));
  reduced.addEventListener('change', () => { paused = reduced.matches; title.getAnimations().forEach(animation => animation.cancel()); updateControl(); schedule(); });
  updateControl();
  schedule();
})();
